// extracted by mini-css-extract-plugin
export default {"container":"LogicalForm_container__Quf6-","row":"LogicalForm_row__ggmRm","field":"LogicalForm_field__lVXjR"};